module.exports = __webpack_public_path__ + "static/media/CityPortalOrangeIcon.30684b6b.svg";